<template>
    <div class="type-ahead">
        <element-loader
            :loading="loading"
            :width="30"
            :height="30"
        />
        <b-input-group>
            <b-input-group-prepend v-if="icon">
                <span class="input-group-text-coherent">
                    <i :class="icon" />
                </span>
            </b-input-group-prepend>
            <b-form-input
                :class="{'border-left-0': icon}"
                v-model="searchValue"
                :placeholder="placeholder"
                :autofocus="autofocus"
                @keyup.down.stop="handleArrowDown"
                @keyup.up.stop="handleArrowUp"
                @keyup.enter.stop="handleEnter"
            />
        </b-input-group>
        <ul
            class="dropdown-menu p-0"
            v-if="dropdownOptions.length"
        >
            <template v-for="(option, index) in dropdownOptions">
                <slot
                    name="option"
                    :option="option"
                    :index="index"
                    :handler="addOption"
                >
                    <li
                        :key="option.value"
                        class="dropdown-item cursor-pointer"
                        @click.stop="() => addOption(option)"
                        :class="{
                                'highlight': activeItem === index
                            }"
                    >
                        {{ option.text }}
                    </li>
                </slot>
            </template>
        </ul>
    </div>
</template>

<script>
    import './TypeAhead.scss';
    import VModel from '../../mixins/VModel';
    import ElementLoader from '../ElementLoader/ElementLoader.vue';

    export default {
        name: 'TypeAhead',

        components: {
            ElementLoader,
        },

        mixins: [
            VModel,
        ],

        props: {
            autofocus: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },

            options: {
                type: Array,
                default: () => [],
            },

            multiple: {
                type: Boolean,
                default: false,
            },

            placeholder: {
                type: String,
                default: '',
            },

            icon: {
                type: String,
                default: '',
            },

            reduceOption: {
                type: Function,
                default(option) {
                    return option;
                },
            },

            optionsFilter: {
                type: Function,
                default(option) {
                    return option.value.includes(this.searchValue.toLowerCase()) && !this.internalModel.includes(option.text);
                }
            },
        },

        data() {
            return {
                searchValue: null,
                activeItem: null,
            };
        },

        watch: {
            searchValue(newVal) {
                this.$emit('search', newVal);
            },

            activeItem(newVal) {
                this.$emit('highlight', newVal);
            },

            value: {
                deep: true,
                handler() {
                    this.searchValue = null;
                },
            },
        },

        computed: {
            dropdownOptions() {
                if (!this.searchValue) {
                    return [];
                }

                let options = [];
                for (const option of this.options) {
                    if (this.optionsFilter(option)) {
                        options.push(option);
                    }
                }
                return options;
            }
        },

        methods: {
            handleArrowDown() {
                if (this.activeItem == null) {
                    this.activeItem = 0;
                    return;
                }
                if (this.activeItem < (this.dropdownOptions.length - 1)) {
                    this.activeItem++;
                }
            },

            handleArrowUp() {
                if (this.activeItem > 0) {
                    this.activeItem--;
                }
            },

            handleEnter() {
                if (this.activeItem == null) {
                    return;
                }
                let resource = this.dropdownOptions[this.activeItem];
                if (resource) {
                    this.addOption(resource);
                }
                this.activeItem = null;
            },

            addOption(option = null) {
                if (this.multiple) {
                    this.internalModel.push(this.reduceOption(option));
                    return;
                }
                this.internalModel = this.reduceOption(option);
            },
        },
    };
</script>
